<ul class="list-unstyled">
  <li>
    <a (click)="navigateTo()">
      <ng-container *ngTemplateOutlet="previousArrow"></ng-container>
      {{ previous_label }}
    </a>
  </li>

  <li>
    <a (click)="navigateTo('next')">
      {{ next_label }}
      <ng-container *ngTemplateOutlet="nextArrow"></ng-container>
    </a>
  </li>
</ul>

<ng-template #previousArrow>
  <svg class="arrow-left" width="22" height="15" xmlns="http://www.w3.org/2000/svg" viewbox="0 0 22 15">
    <g>
      <path fill="none" stroke="#000" stroke-linecap="square" d="M1.25 7.47h20" id="Line"></path>
      <path fill="none" stroke="#000" d="M6.75 14.97l-6-7.55 7-7.39"></path>
    </g>
  </svg>
</ng-template>

<ng-template #nextArrow>
  <svg class="arrow-right" width="22" height="15" viewbox="0 0 22 15" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <path stroke="#000" d="M20.5 7.5H.5" stroke-linecap="square"></path>
      <path stroke="#000" d="M14.999 14.998L21 7.449 14 .063"></path>
    </g>
  </svg>
</ng-template>
